module.exports = __webpack_public_path__ + "static/media/digitalagency-freelancer-hero-image.38b2b307.webp";